import Warn from './Warn';
import Notification from './Notification';
import CreateTicket from './CreateTicket';
import CreatePost from './CreatePost';
import CreateAudit from './CreateAudit';
import AuditFiles from './AuditFiles';
import CreateGoal from './CreateGoal';
import CreateSource from './CreateSource';

export default {
    Warn,
    Notification,
    CreateTicket,
    UpdateTicket: CreateTicket,
    CreatePost,
    UpdatePost: CreatePost,
    CreateAudit,
    AuditFiles,
    CreateGoal,
    UpdateGoal: CreateGoal,
    CreateSource,
    UpdateSource: CreateSource,
};



// WEBPACK FOOTER //
// ./src/components/modals/index.js